import * as msal from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: '49530f18-8c74-4c9d-929a-af371204848b',
    // authority: 'https://SiliconCraftTechnologyB2C.b2clogin.com/SiliconCraftTechnologyB2C.onmicrosoft.com/B2C_1_customer_signupsignin',
    authority: 'https://SiliconCraftTechnologyB2C.b2clogin.com/SiliconCraftTechnologyB2C.onmicrosoft.com/B2C_1A_DEMO_SIGNUP_SIGNIN_SPLITEMAILVERIFICATIONANDSIGNUP',
    knownAuthorities: ['SiliconCraftTechnologyB2C.b2clogin.com'],
  },
  cache: {
    cacheLocation: 'localStorage',
  },
}

const msalInstance = new msal.PublicClientApplication(msalConfig);

export default {
  myMSALConfig: msalConfig,
  myMSAL: msalInstance,
  myAccounts: '',
  authError: '',
  async SignIn() {
    var authStatus = false;
    await msalInstance.handleRedirectPromise(); 
    console.log("Clear any Promise and Start Login");
    localStorage.clear();
    await msalInstance
    .loginPopup({})
    .then(() => {
      var allAccounts = msalInstance.getAllAccounts();
      this.myAccounts = allAccounts[0];
      console.log(allAccounts);
      if((this.myAccounts != null) || (this.myAccounts != ""))
      {
        authStatus = true;
      }
      else
      {
        authStatus = false
        this.authError = "Account not found."
      }
      
      console.log("Complete Login");
    })
    .catch(error => {
      console.error(`Error during authentication: ${error}`);
      msalInstance.handleRedirectPromise(); 
      authStatus = false
      this.authError = "Login failed."
    });
    return authStatus;
  },
  async SignOut() {
    var authStatus = false;
    await msalInstance.logoutPopup({})
    .then(() => {
      authStatus = true;
    })
    .catch(error => {
      console.error(`Error during authentication: ${error}`);
      msalInstance.handleRedirectPromise(); 
      authStatus = false
      this.authError = "Logout failed."
    });
    return authStatus;
  }
}